import schema from "./behaviour.schema.json";

// Single source of truth: the JSON-schema pattern also drives the widget's inline validation.
const TICKER_LIST_PATTERN = new RegExp(schema.properties.customEstablishmentOrder.pattern);

export const isValidTickerList = (value: string): boolean =>
  !value || TICKER_LIST_PATTERN.test(value);
